import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/auth/services/auth.service';

@Component({
  selector: 'cert-selector',
  templateUrl: './selector.component.html',
  styles: ``,
  standalone: false,
})
export class SelectorComponent {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {}

  standardLogin() {
    this.authService.login();
  }

  testUserLogin() {
    this.router.navigateByUrl('launch/configure');
  }
}
